<div class="access-log-component-container page-root-container">
        <div class="page-header">
                <div class="page-title">

                        <img class="icon" src="/assets/images/menu/svg/access-log.svg"><span class="title">Access
                                Log</span>
                </div>
                <div class="page-actions">
                        <!-- <button mat-button color="primary" class="btn-add"
                            (click)="addClicked()"><mat-icon>person_add</mat-icon>New</button> -->
                        @if(permission.can_export || permission.can_execute){
                        <button mat-button color="accent" class="btn-export" (click)="exportClicked()"
                                [disabled]="IsDownloading">
                                <img class="download-icon"
                                        [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                                Export
                        </button>
                        }
                </div>
        </div>

        <div class="data-container ">
                <app-loader [show]="isLoading"></app-loader>

                <!-- <app-search-filter #searchFilter [length]="pagingData.length" [pageSize]="pagingData.pageSize"
                    [pageSizeOptions]="[5,10,20,50,100]" [pageIndex]="pagingData.pageIndex" [filter]="filter"
                    (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"  [hidePageSize]="true">
            </app-search-filter> -->
                <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
                        [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"
                        [hidePageSize]="true">
                </app-search-filter>
                <!-- <ng-container *ngIf="pagingData.length>0; else nodata"> -->
                <!-- @if(pagingData.length > 0){
                            @if(!isHandset){ -->
                <section tabindex="0" class="table-container">
                        <table matSort mat-table [dataSource]="dataSource">
                                <ng-container matColumnDef="item">
                                        <th mat-header-cell *matHeaderCellDef (click)="sortData($event)"
                                                class="item-header">#</th>
                                        <td mat-cell *matCellDef="let access; let i = index" class="item-column">{{
                                                (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
                                </ng-container> (matSortChange)="sortData($event)">

                                <ng-container matColumnDef="function_name">
                                        <th mat-sort-header="access_log_function.function_name" mat-header-cell
                                                *matHeaderCellDef (click)="sortData($event)"> Function </th>
                                        <td mat-cell *matCellDef="let access"> {{access.function_name}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="description">
                                        <th mat-header-cell *matHeaderCellDef> Description </th>
                                        <td mat-cell *matCellDef="let access"> {{access.data?.description}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="user_name">
                                        <th mat-sort-header="user_name" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> User </th>
                                        <td mat-cell *matCellDef="let access"> {{access.user_name}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="station_name">
                                        <th mat-sort-header="stations.name" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Station </th>
                                        <td mat-cell *matCellDef="let access"> {{access.station_name}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="access_time">
                                        <th mat-sort-header="access_time" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Time </th>
                                        <td mat-cell *matCellDef="let access"> {{access.access_time | date: 'dd-MM-yyyy
                                                hh:mm a' }}
                                        </td>
                                </ng-container>
                                <!-- <ng-container matColumnDef="data">
                                    <th mat-sort-header="data" mat-header-cell *matHeaderCellDef
                                            (click)="sortData($event)"> Data </th>
                                    <td mat-cell *matCellDef="let access">
                                        <ng-container *ngIf="access.data && access.data !== 'null'">
                                        <img src="assets/images/icons/popup.svg" alt="" style="height: 20px; width: 20px;">
                                      </ng-container>
                                    </td>
                            </ng-container> -->
                                <ng-container matColumnDef="action" stickyEnd>
                                        <th mat-header-cell *matHeaderCellDef> </th>
                                        <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let rowItem">
                                                <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                                                        (click)="onRowSelected(rowItem);$event.stopPropagation();">
                                                        <mat-icon>more_vert</mat-icon>
                                                </a>

                                                <mat-menu #rowMenu>

                                                        <button mat-menu-item
                                                                (click)="openViewDialog(rowItem)">View</button>
                                                </mat-menu>
                                        </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                                </tr>
                                <tr mat-row class="table-element-row"
                                        *matRowDef="let access; columns: displayedColumns;"
                                        (dblclick)="openViewDialog(access)">
                                </tr>
                        </table>
                </section>

                <!-- </ng-container> -->
                <!-- <ng-template #nodata> -->
                @if(pagingData.length<=0){ <div class="no-data-container">
                        <img src="assets/images/no-data.png">
                        <span class="no-data-info">No data found. Please remove or redefine the filters if
                                any.</span>
        </div>
        <!-- </ng-template> -->
        }
</div>

</div>